import * as i18nIsoCountries from 'i18n-iso-countries';
import { Country } from '../models/country.model';

export class CountryService {
  public static getAllCountries(alphaCode: string): Array<Country> {
    const countries = [];
    const countriesObject = i18nIsoCountries.getNames(alphaCode);
    for (const c of Object.keys(countriesObject)) {
      countries.push({
        label: countriesObject[c],
        value: c,
      });
    }
    countries.sort((a, b) => {
      if (a.label > b.label) {
        return 1;
      }
      if (a.label < b.label) {
        return -1;
      }
      return 0;
    });

    return countries;
  }

  public static getAlphaCode(countryName: string, alphaCode: string): string {
    return i18nIsoCountries.getAlpha2Code(countryName, alphaCode);
  }
}
